// import styled, { css } from 'styled-components';
// import { animated } from 'react-spring';
// import { darken } from 'polished';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c   --ink: #2c405a   --muted: #98a5b7
//    Preserva theme.treeViewLinkColor / theme.color e a prop selected.
// =========================================================== */

// export const Container = styled.div`
//   padding: 3px 0 3px 10px;
//   width: 100%;
// `;

// export const Title = styled.div`
//   display: flex;
//   align-items: stretch;

//   > a {
//     display: flex;
//     align-items: center;
//     width: 100%;
//     padding: 6px 9px;
//     border-radius: 9px;
//     color: ${(props) => props.theme.treeViewLinkColor};
//     font-size: 14px;
//     transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;

//     > svg {
//       margin-right: 5px;
//       color: #98a5b7;
//       transition: color 0.18s ease;
//     }

//     :hover {
//       color: ${darken(0.05, '#2c405a')};
//       background: rgba(255, 109, 60, 0.08);

//       > svg {
//         color: #ff6d3c;
//       }
//     }

//     ${(props) =>
//       props.selected &&
//       css`
//         font-weight: bold;
//         color: ${props.theme.color};
//         background: rgba(255, 109, 60, 0.12);
//         box-shadow: inset 3px 0 0 #ff6d3c;

//         > svg {
//           color: #ff6d3c;
//         }
//       `}
//   }
// `;

// export const Content = styled(animated.div)`
//   padding: 2px 0 2px 15px;
//   will-change: transform, opacity, height;
//   margin-left: 6px;
//   border-left: 1px dashed rgba(148, 163, 184, 0.5);
//   overflow: hidden;
// `;

import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --ink: #2c405a   --muted: #98a5b7
   Preserva theme.treeViewLinkColor / theme.color e a prop selected.
=========================================================== */

export const Container = styled.div`
  padding: 2px 0 2px 8px;
  width: 100%;
`;

export const Title = styled.div`
  display: flex;
  align-items: stretch;

  > a {
    display: flex;
    align-items: center;
    width: 100%;

    /** 34px mantém o alvo de toque confortável em tablet */
    min-height: 34px;
    padding: 6px 8px;
    border-radius: 9px;
    color: ${(props) => props.theme.treeViewLinkColor};
    font-size: 13px;
    line-height: 1.3;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;

    > svg {
      flex: 0 0 auto;
      margin-right: 5px;
      color: #98a5b7;
      transition: color 0.18s ease;
    }

    :hover {
      color: ${darken(0.05, '#2c405a')};
      background: rgba(255, 109, 60, 0.08);

      > svg {
        color: #ff6d3c;
      }
    }

    ${(props) =>
      props.selected &&
      css`
        font-weight: bold;
        color: ${props.theme.color};
        background: rgba(255, 109, 60, 0.12);
        box-shadow: inset 3px 0 0 #ff6d3c;

        > svg {
          color: #ff6d3c;
        }
      `}
  }
`;

export const Content = styled(animated.div)`
  padding: 2px 0 2px 10px;
  will-change: transform, opacity, height;
  margin-left: 5px;
  border-left: 1px dashed rgba(148, 163, 184, 0.5);
  overflow: hidden;
`;
